<template>
  <div>
    <!--    更换课程筛选项-->
    <div class="filter_fields">
      <div class="filter_fields_header">
        <div
          v-for="(item, index) of filterList"
          :key="index"
          class="filter_fields_header_tag"
          @click="handleShowMask(item.type, index, item.typeName)"
        >
          <span
            :class="{
              filter_fields_header_tag_redfont:
                item.isSelect === 2 || item.isSelect === 1,
              filter_fields_header_tag_font: item.isSelect === 0,
            }"
          >
            {{ item.typeName }}
          </span>
          <img
            :src="
              item.isSelect === 0
                ? 'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/black-arrow-icon.png'
                : item.isSelect === 1
                ? 'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/red-arrow-icon.png'
                : 'https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/black-arrow-icon.png'
            "
            class="img_search"
          />
        </div>
      </div>
    </div>
    <!-- isShowMask -->
    <div
      v-if="isShowMask"
      :class="['mask', $isInApp ? 'mask-top-app' : 'mask-top-h5']"
      @click="handleIsShowMask('click')"
    >
      <div class="mask_point">
        <div class="filter_fields_select" style="flex-wrap: wrap">
          <div
            v-for="(item, index) of tagList"
            :key="index"
            :class="item.id === isTagActive ? 'red-tag' : 'common-tag'"
            @click="handleSearchTag(item.id, item.name)"
          >
            <span>
              {{ item.name }}
            </span>
          </div>
          <div
            v-if="tagList.length % 3 !== 0"
            class="common-tag invisible"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WXJsBridge from "@xes/wxjsbridge";

export default {
  name: "FilterList",
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tagSelectActive: {
      data: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    ableChoose: {
      data: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
  },
  data() {
    return {
      isShowMask: false,
      xesAppStatusBarHeight: 0,
      isActive: -1,
      isTagActive: -1,
      tagList: [], // 筛选项下拉数据
      tagType: "",
    };
  },
  mounted() {
    if (this.$isInApp) {
      WXJsBridge.setNavigationBar({
        hidden: 1,
      });
      this.xesAppStatusBarHeight = window.xesApp.getStatusBarHeight();
    }
  },
  computed: {
    filterList() {
      return this.list;
    },
    tagSelectActiveList() {
      return this.tagSelectActive;
    },
  },
  methods: {
    /** 打开筛选项 */
    handleShowMask(type, index, typeName) {
      this.isShowMask = !this.isShowMask;
      // console.log(1, this.isShowMask);
      this.isActive = index;
      const filter = this.tagSelectActiveList?.filter(
        (item) => item.type === type
      );
      if (filter.length <= 0) {
        this.tagSelectActiveList.push({
          type: type,
          id: "",
        });
      } else {
        this.isTagActive = filter[0].id;
      }
      if (type === "time") {
        this.tagList = this.ableChoose.time;
      } else if (type === "time_slot") {
        this.tagList = this.ableChoose.time_slot;
      } else if (type === "learning_stage") {
        this.tagList = this.ableChoose.learning_stage;
      } else if (type === "difficulty") {
        this.tagList = this.ableChoose.difficulty;
      } else if (type === "version") {
        this.tagList = this.ableChoose.version;
      }
      this.tagType = type;
      this.handleIsShowMask();
    },
    handleIsShowMask() {
      // 关闭弹窗
      if (!this.isShowMask) {
        this.filterList?.map((item) => {
          if (item.red === 2) {
            item.isSelect = 2;
          } else {
            item.isSelect = 0;
          }
        });
      } else {
        // 打开弹窗
        if (this.filterList[this.isActive].isSelect === 2) {
          this.filterList[this.isActive].red = 2;
        }
        this.filterList[this.isActive].isSelect = 1;
      }
    },
    /** 筛选项 */
    handleSearchTag(id, name) {
      const _this = this;
      this.tagSelectActiveList?.map((item) => {
        if (item.type === _this.filterList[_this.isActive].type) {
          if (item.id !== "") {
            if (Number(item.id) === Number(id)) {
              item.id = "";
              _this.isTagActive = -1;
              let typeName = "";
              if (_this.filterList[_this.isActive].type === "time") {
                typeName = "时间";
              }
              if (_this.filterList[_this.isActive].type === "time_slot") {
                typeName = "时段";
              }
              if (_this.filterList[_this.isActive].type === "learning_stage") {
                typeName = "进度";
              }
              if (_this.filterList[_this.isActive].type === "difficulty") {
                typeName = "难度";
              }
              if (_this.filterList[_this.isActive].type === "version") {
                typeName = "版本";
              }
              _this.filterList[_this.isActive].typeName = typeName;
              _this.filterList[_this.isActive].red = 0;
              _this.filterList[_this.isActive].isSelect = 0;
            } else {
              item.id = id;
              _this.isTagActive = id;
              _this.filterList[_this.isActive].typeName = name;
              _this.filterList[_this.isActive].red = 2;
              _this.filterList[_this.isActive].isSelect = 2;
            }
          } else {
            item.id = id;
            _this.isTagActive = id;
            _this.filterList[_this.isActive].typeName = name;
            _this.filterList[_this.isActive].red = 2;
            _this.filterList[_this.isActive].isSelect = 2;
          }
        }
      });
      this.isShowMask = false;
      this.$emit("change", id, name, this.tagType);
    },
  },
  watch: {
    isShowMask(val) {
      // 当为true时，修改body overflow:hidden
      if (val) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mask-top-app {
  top: 133px; // 当前过滤条的高度45+顶部导航端内高度88
}
.mask-top-h5 {
  top: 89px; // 当前过滤条的高度45+顶部导航h5高度44
}
.filter_fields {
  box-sizing: border-box;
  &_header {
    display: flex;
    width: 100vw;
    height: 45px;
    background: #ffffff;
    z-index: 10;

    &_tag {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      &_font {
        color: #333;
        font-family: PingFang SC;
        font-size: 15px;
        font-weight: 400;
      }

      &_redfont {
        color: #f93834;
        font-family: PingFang SC;
        font-size: 15px;
        font-weight: 400;
        overflow: hidden;
        //显示省略符号来代表被修剪的文本
        text-overflow: ellipsis;
        //文本不会换行，文本会在在同一行上继续，直到遇到 <br> 标签为止。
        white-space: nowrap;
      }
    }
  }

  &_select {
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px 12px 12px;
  }

  // 内容
  &_content {
    border-radius: 10px;
    padding: 100px 12px 22px 12px;
    position: initial;
    background: #f7f7f8;
  }
}
.common-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 109px;
  margin-top: 12px;
  height: 40px;
  border-radius: 20px;
  padding: 0 12px;
  background-color: rgba(153, 153, 153, 0.1);
  color: #333;
  span {
    text-align: center;
    width: 100%;
    font-family: PingFang SC;
    font-size: 13px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }
}
.red-tag {
  .common-tag;
  background-color: #ffefef;
  color: #f93834;
}
.invisible {
  visibility: hidden;
}
</style>
